import { controls } from "../controls";
const ms301 = {
  label: "Member Master",
  pageLabel: "Member Master",
  starting: true,
  url: "ms301",
  formActions: { edit: { allow: true } },
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Create Member Master",
        uid: "create",
        style: { fontFamily: "verdana" }
      },
    ]
  },

  filter: [

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", }),

    ...controls.magicDateLabel({ tab: "filter", label: "Opening Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "filterOpeningDate", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Member Type", star: true, width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "member_type", isRequired: true, width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),


    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Search", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "search", width: "col-sm-2", placeHolder: "Enter Search" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Member Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "filter", onChangeSet: { customer_changed: true } }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Number Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Customer Type", width: "col-sm-2" }),
    ...controls.CustomerType({ tab: "filter" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "filter", default: true, label: "Active", name: "isActive", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-3" }),

    ...controls.displayText({ tab: "filter", label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "filter", onChangeSet: { customer_changed: true } }),

    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "Full Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "Enter Name", name: "customer_number_display", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "Last Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "Enter Last Name", name: "last_name", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "First Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "Enter First Name", name: "first_name", width: "col-sm-4" }),

  ],
  form: [
    {
      widths: "col-sm-10",
      tab: "create",
      style: { border: 0, paddingTop: 0 },
      subComponents: [
        {
          widths: "col-sm-12",
          tab: "create",
          title: "Personal Info",
          subComponents: [
            ...controls.displayText({ tab: "create", star: true, label: "Parent Branch", width: "col-sm-2" }),
            ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, defaultValue: "assigned_branch" }),
            ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),

            ...controls.displayText({ tab: "create", width: "col-sm-6" }),

            ...controls.displayText({ tab: "filter", label: "Member Type", star: true, width: "col-sm-2" }),
            ...controls.select({
              tab: "filter", name: "member_type", isRequired: true, width: "col-sm-2", placeHolder: "Select", defaultValue: "",
              options: [{
                label: "Regular",
                value: "regular"
              },
              {
                label: "Associated",
                value: "associated"
              },
              {
                label: "Nominal (B-Class)",
                value: "nominal"
              }]
            }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),

            ...controls.displayText({ tab: "create", label: "Last A/c No.", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", data: "last_ac_no", name: "last_accno", width: "col-sm-2" }),

            ...controls.displayText({ tab: "create", width: "col-sm-1" }),

            ...controls.displayText({ tab: "create", star: true, label: "Customer Type", width: "col-sm-2" }),
            ...controls.CustomerType({ tab: "create", isRequired: true, width: "col-sm-2", name: "customer_type" }),

            ...controls.displayText({ width: "col-sm-8" }),

            ...controls.displayText({ tab: "create", label: "Customer Number", width: "col-sm-2", star: true }),
            ...controls.customerNumber({ tab: "filter", onChangeSet: { customer_changed: true } }),


            ...controls.displayText({ tab: "create", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),

            ...controls.checkBox({ tab: "create", isRequired: true, star: true, default: true, label: "Active", name: "isActive", }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),

            ...controls.displayText({ tab: "create", label: "Member No.", width: "col-sm-2" }),
            ...controls.showData({
              tab: "create", width: "col-sm-4", data: "member_number", name: "member_number", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.displayText({ tab: "create", width: "col-sm-6" }),

            ...controls.displayText({ tab: "create", label: "Name", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-4", data: "customer_number_display", name: "customer_number_display" }),
            ...controls.displayText({ tab: "create", width: "col-sm-6" }),

            ...controls.displayText({ tab: "create", label: "Address", width: "col-sm-2" }),
            ...controls.showData({
              tab: "create", width: "col-sm-6", data: "address", name: "address", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),
            ...controls.displayText({ tab: "create", width: "col-sm-4" }),
            ...controls.displayText({ tab: "create", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "add2", name: "add2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "pin", name: "pin" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "state", name: "state" }),

            ...controls.displayText({ tab: "create", width: "col-sm-4" }),

            ...controls.displayText({ tab: "create", label: "Phone No:", width: "col-sm-2" }),

            ...controls.displayText({ tab: "create", width: "col-sm-2" }),

            ...controls.displayText({ tab: "create", label: "Date Of Birth:", width: "col-sm-2" }),
            ...controls.showData({
              tab: "create", width: "col-sm-2", data: "dob", name: "dob", displaytype: 'date', onRender: [
                // // sum last column of the current table
                { f: 'calculateAge', calcType: 'sum', inputs: { source: 'pageData.dob', field: 'dob' }, resultVar: 'getCalulateage' },
                // // and set it as some other parentState.
                { f: 'setParentState', inputs: { dest: "pageData.age", source: 'allResults', field: 'getCalulateage' }, resultVar: "age" },
              ]
            }),
            ...controls.displayText({ tab: "create", label: "Age:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "age", name: "age" }),

            ...controls.displayText({ tab: "create", label: "Gender:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "gender", name: "gender" }),

            ...controls.displayText({ tab: "create", label: "Occupation:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "occupation", name: "occupation" }),

            ...controls.displayText({ tab: "create", label: "Balance:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "cintotbal", name: "cintotbal", displaytype: "currency" }),

            ...controls.displayText({ tab: "create", label: "PAN:", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "panid", name: "panid" }),

            ...controls.displayText({ tab: "create", label: "Aadhar UID", width: "col-sm-2" }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "aadhar_id", name: "aadhar_id" }),


          ],
        },



        {
          widths: "col-sm-12",
          tab: "create",
          title: "Account Info",
          subComponents: [

            ...controls.displayText({ tab: "create", star: true, label: "Account Type", width: "col-sm-2", star: true }),

            ...controls.AccountType({
              tab: "create", width: "col-sm-2", isRequired: true, parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ],
            }),
            ...controls.showData({
              tab: "create", data: "account_type_display", width: "col-sm-2", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ],
            }),

            ...controls.checkBox({
              tab: "create", width: "col-sm-2", label: "Want SMS", name: "isWantsms", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),

            ...controls.magicDateLabel({ tab: "create", label: "Close Date", width: "col-sm-2" }),
            ...controls.magicDate({
              tab: "create", dateType: "ontype", name: "close_date", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),

            ...controls.displayText({ tab: "create", star: true, label: "Mode Of Operation", width: "col-sm-2" }),
            ...controls.ModeOfOperation({
              tab: "create", isRequired: true, width: "col-sm-2", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),

            ...controls.displayText({ tab: "create", width: "col-sm-2" }),


            ...controls.checkBox({
              tab: "create", width: "col-sm-2", label: "Expired", name: "isExpired", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),

            ...controls.magicDateLabel({ tab: "create", label: "Expired On", width: "col-sm-2" }),
            ...controls.magicDate({
              tab: "create", dateType: "ontype", name: "expired_on", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),

            ...controls.magicDateLabel({ tab: "create", star: true, label: "Account Opening Date", width: "col-sm-2" }),
            ...controls.magicDate({
              isRequired: true, dateType: "ontype", default: "sessiondate", name: "account_opening_date", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-4"
            }),

            ...controls.checkBox({
              tab: "create", width: "col-sm-2", label: "Photo Received", name: "isPhotoReceived", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),

            ...controls.magicDateLabel({ tab: "create", label: "Photo Recd On", width: "col-sm-2" }),
            ...controls.magicDate({
              tab: "create", dateType: "ontype", name: "photo_recd_on", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'

                }
              ], width: "col-sm-2"
            }),

            ...controls.magicDateLabel({ tab: "create", label: "Admission Fee Date", width: "col-sm-2" }),
            ...controls.magicDate({
              tab: "create", dateType: "ontype", name: "admission_fee_date", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),

            ...controls.displayText({ tab: "create", width: "col-sm-2" }),

            ...controls.checkBox({
              tab: "create", width: "col-sm-2", label: "ICard Sent", name: "isICardSent", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ]
            }),

            ...controls.magicDateLabel({ tab: "create", label: "ICard Sent On", width: "col-sm-2" }),
            ...controls.magicDate({
              tab: "create", dateType: "ontype", name: "i_card_sent_on", parents: [
                {
                  name: "customer_number_display",
                  match: "exist",
                  show: 'readonly'
                }
              ], width: "col-sm-2"
            }),


          ],
        },

        {
          widths: "col-sm-12",
          tab: "create",
          title: "Divident Transfer To",
          subComponents: [

            ...controls.displayText({ tab: "create", label: "Product", width: "col-sm-2" }),
            ...controls.product({ tab: "create", width: "col-sm-2", sendToServer: { dataType: 'product', sendData: [{ varname: 'product_group', fixed: "Deposit" }] } }),
            ...controls.showData({ tab: "create", width: "col-sm-2", data: "product_code_display", name: "product_code_display", }),
            // ...controls.displayText({ tab: "filter", label: "Search", width: "col-sm-2" }),

            // ...controls.text({ tab: "filter", name: "search", width: "col-sm-2", placeHolder: "Enter Search" }),
            ...controls.displayText({ tab: "create", width: "col-sm-4" }),

            ...controls.displayText({ tab: "create", width: "col-sm-2" }),
            ...controls.displayText({ tab: "create", label: "Account No.", width: "col-sm-2" }),
            ...controls.numberOnly({ tab: "create", name: "account_number", placeHolder: "Enter Account No", width: "col-sm-2" }),


          ]
        }

      ]
    },
    {
      widths: "col-sm-2",
      tab: "create",
      style: {
        border: "none",
        marginTop: 0,
        padding: 0
      },
      subComponents: [
        // ...controls.footerButtonsDeposit(),
      ]
    },




    // {
    //   inputType: "handsonTable",
    //   widths: {
    //     parent: "col-sm-12",
    //     children: "col-sm-12"
    //   },
    //   tab: "nominees",
    //   label: "Nominees",
    //   name: "recurringdepositNominees",
    //   description: "none",
    //   tableOptions: {
    //     // validations, basic calculations, colors, date pickers, context menu etc.
    //     HOTheaders: [
    //       "Name",
    //       "Address.",
    //       "Rel Code",
    //       "Relation",
    //       "Birthdate",
    //       "Age",
    //       "Guardian",
    //       "Given Date"
    //     ],
    //     columns: [
    //       {},
    //       {},
    //       {},
    //       {},
    //       { type: "date" },
    //       { type: "numerico" },
    //       {},
    //       { type: "date" }
    //     ],
    //     rowHeaders: false,
    //     // contextMenu: true,
    //     minSpareRows: 4,
    //     stretchH: "last",
    //     // columnSorting: true,
    //     autoWrapRow: true,
    //     maxRows: 100
    //   }
    // },


  ],
  history: {
    perPage: 10,
    reportHeader: "Member Master",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Branch",
        accessor: "branch_display",
        width: 150, type: "small"

      },
      {
        Header: "Cust No",
        accessor: "customer_number"
      },
      {
        Header: "Member Type",
        accessor: "member_type",
      },
      {
        Header: "Member No",
        accessor: "member_number",
        width: 150
      },

      {
        Header: "Full Name",
        accessor: "full_name",
        width: 150
      },
      {
        Header: "Open Date",
        accessor: "opening_date"
      },
      {
        Header: "Admn Fee Date",
        accessor: "admn_fee_date"
      },
      {
        Header: "Close Date",
        accessor: "closing_date"
      },
      {
        Header: "Divident to",
        accessor: "divident_to"
      },
      {
        Header: "Modified By",
        accessor: "last_modified_by"
      },
      {
        Header: "Modified Date",
        accessor: "last_modify_date"

      },
      {
        Header: "Modified Time",
        accessor: "last_modify_time",
        show: false
      },
      {
        Header: "Active",
        accessor: "isActive",
        type: "tick"
      },
    ]
  }
};

export default ms301;